<template>
  <ModalDefault modal_id="addUserWalletActionsModal" header="y"
    size="modal-md modal-dialog-scrollable" style_header="" :modal_header="getTranslations('expression_831')"
    :footer="[0, 3].includes(wallet.action) || wallet.operator_id > 0" icon="bx bx-wallet mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="d-flex">
          <div class="cursor-default w-100" style="align-items: center; align-self: center;">
            <div class="d-block pt-0 px-2">
              <div class="animated--grow-in col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_4') }} </label>
                <div class="input-group mb-3">
                  <select @change.prevent="wallet.department_id = null" v-model="wallet.channel_id"
                    class="input_forms custom-select px-50">
                    <option :value="null">{{ getTranslations('expression_7') }}</option>
                    <option v-for="channel in channels.data" v-show="channel.status_key === 1" :key="channel.id"
                      :value="channel.id">
                      {{ channel.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="wallet.channel_id > 0" class="col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_12') }} </label>
                <div class="input-group mb-3">
                  <select v-model="wallet.department_id" @change.prevent="checkOperatorOld()"
                    class="input_forms custom-select px-50">
                    <option :value="null">{{ getTranslations('expression_124') }}</option>
                    <option v-for="department in getDepartmentsArray('channel_id', wallet.channel_id)"
                      :key="department.id" v-show="isOperator(department.id)" :value="department.id">
                      {{ department.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="wallet.channel_id > 0 && wallet.department_id > 0" class="col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_198') }} </label>
                <div class="input-group mb-3">
                  <select v-model="wallet.action" class="input_forms custom-select px-50">
                    <option :value="null">{{ getTranslations('expression_832') }}</option>
                    <option :value="0">{{ getTranslations('expression_833') }}</option>
                    <option :value="1">{{ getTranslations('expression_834') }}</option>
                    <option :value="2">
                      Compartilhar Carteira </option>
                    <option :value="3">
                      Remover Compartilhamento
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="wallet.action === 1 || wallet.action === 2" class="col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_48') }} </label>
                <div class="input-group mb-3">
                  <select v-model="wallet.operator_id" class="input_forms custom-select px-50">
                    <option :value="null">{{ getTranslations('expression_605') }}</option>
                    <option v-for="operator in getOperatorsArray('department_id', wallet.department_id)"
                      v-if="[0, 1].includes(getUserObject('id', operator.user_id).role_key)" :key="operator.id"
                      :value="operator.id" v-show="isOperator(wallet.department_id) !== operator.id">
                      {{ getUserObject('id', operator.user_id).name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div v-if="wallet.action === 0">
        <span @click.prevent="removeWallets"
          class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
          <span class="">{{ getTranslations('expression_835') }}</span>
        </span>
      </div>
      <div v-if="wallet.action === 1">
        <span @click.prevent="transferWallets"
          class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
          <span class="">{{ getTranslations('expression_538') }}</span>
        </span>
      </div>
      <div v-if="wallet.action === 2 && wallet.operator_id">
        <span @click.prevent="shareWallets"
          class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3">
          <span>Compartilhar Carteira</span>
        </span>
      </div>
      <div v-if="wallet.action === 3">
        <span @click.prevent="removeShareWallets"
          class="shadow-sm cursor_pointer animated--grow-in btn-danger text-white py-2 px-3">
          <span>Remover Compartilhamento</span>
        </span>
      </div>

    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../general/ModalDefault";
import { mapGetters, mapState } from "vuex";
export default {
  name: "ModalUserWalletActions",
  components: {
    ModalDefault,
  },
  data() {
    return {
      wallet: {
        channel_id: null,
        department_id: null,
        operator_id: null,
        action: null,
        operator_old: null,
        shared_operator_id: null
      },
    }
  },
  computed: {
    ...mapState(['leads', 'wallets', 'users', 'channels', 'operators']),
    ...mapGetters([
      'getUserObject',
      'getDepartmentsArray',
      'getOperatorObject',
      'getOperatorsArray',
      'getChannelObject',
    ]),
  },
 mounted() {
  // Garante reset de estado após o modal sumir visualmente
  $('#addUserWalletActionsModal').on('hidden.bs.modal', () => {
    this.wallet = {
      channel_id: null,
      department_id: null,
      operator_id: null,
      action: null,
      operator_old: null
    };

    // Reseta selects visualmente
    $('#addUserWalletActionsModal select').val(null).trigger('change');
  });

  // Se quiser abrir via evento Vue global
  this.$root.$on('openUserWalletActionsModal', () => {
    $('#addUserWalletActionsModal').modal('show');
  });

  // Se quiser fechar via evento
  this.$root.$on('closeUserWalletActionsModal', () => {
    $('#addUserWalletActionsModal').modal('hide');
  });
},
  methods: {
    resetWallet() {
      // Use $nextTick para garantir que a atualização seja processada
      this.$nextTick(() => {
        // Reset completo do objeto
        this.wallet = {
          channel_id: null,
          department_id: null,
          operator_id: null,
          action: null,
          operator_old: null,
          shared_operator_id: null
        };

        // Forçar atualização da reatividade
        this.$forceUpdate();

        // Reset dos selects DOM se necessário
        const selects = this.$el.querySelectorAll('select');
        selects.forEach(select => {
          select.selectedIndex = 0;
        });
      });
    },
    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.wallet.channel_id).parameter.department_id
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === parseInt(window.localStorage.getItem("user_id"));
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },
    checkOperatorOld() {
      this.wallet.action = null;
      this.wallet.operator_old = this.isOperator(this.wallet.department_id);
    },
    transferWallets() {
      let operators = this.getOperatorsArray('department_id', this.wallet.department_id);
      let operator = operators.find(operator => operator.user_id == this.users.user.id);

      this.wallet.old_main_operator_id = operator ? operator.id : null;
      this.wallet.new_main_operator_id = this.wallet.operator_id;

      const payload = {
        channel_id: this.wallet.channel_id,
        department_id: this.wallet.department_id,
        old_main_operator_id: this.wallet.old_main_operator_id,
        new_main_operator_id: this.wallet.new_main_operator_id
      };

      this.$store.dispatch('transferWalletMassive', payload);
      $('#addUserWalletActionsModal').modal('hide');
      this.resetWallet();

    },
    removeWallets() {
      let operators = this.getOperatorsArray('department_id', this.wallet.department_id);
      let operator = operators.find(operator => operator.user_id == this.users.user.id);

      const payload = {
        channel_id: this.wallet.channel_id,
        department_id: this.wallet.department_id,
        main_operator_id: operator ? operator.id : null
      };

      this.$store.dispatch('deleteWalletMassive', payload);
      $('#addUserWalletActionsModal').modal('hide');
      this.resetWallet();

    },
    async shareWallets() {
      let operators = this.getOperatorsArray('department_id', this.wallet.department_id);
      let operator = operators.find(op => op.user_id == this.users.user.id);

      const payload = {
        channel_id: this.wallet.channel_id,
        department_id: this.wallet.department_id,
        main_operator_id: operator ? operator.id : null,
        shared_operator_id: this.wallet.operator_id
      };

      try {
        await this.$store.dispatch('shareWalletMassive', payload);
        this.wallet.shared_operator_id = this.wallet.operator_id;
        $('#addUserWalletActionsModal').modal('hide');
        this.$emit('close');
        this.resetWallet();
      } catch (error) {
        console.error(error);
      }
    },
    async removeShareWallets() {
      let operators = this.getOperatorsArray('department_id', this.wallet.department_id);
      let operator = operators.find(op => op.user_id == this.users.user.id);

      const payload = {
        channel_id: this.wallet.channel_id,
        department_id: this.wallet.department_id,
        main_operator_id: operator ? operator.id : null,
      };

      try {
        await this.$store.dispatch('removeShareWalletMassive', payload);
        this.wallet.shared_operator_id = null;
        $('#addUserWalletActionsModal').modal('hide');
        this.$emit('close');
        this.resetWallet();
      } catch (error) {
        console.error(error);
      }
    },

  }
}
</script>